import React from "react";
import {Dropdown, StateOptions} from "gd-react";
import "./GraphRangePicker.scss";
import checkFeature from "../services/SubFeatureCheckService";
import SubTierModal from "../modals/SubTier/SubTierModal";

class GraphTypePicker extends React.PureComponent {
    constructor(props) {
        super(props);

        this.setType = this.setType.bind(this);
        this.setGraphType = this.setGraphType.bind(this);
        this.setAverageType = this.setAverageType.bind(this);
        this.setCombined = this.setCombined.bind(this);
        this.state = {
            openSubTierModal: null,
            tierUpdated: null
        }
    }

    setCombined(e) {
        this.props.onChange({
            graph: this.props.graph,
            type: this.props.type,
            time: this.props.time,
            average: this.props.average,
            combined: e.target.value
        });
    }

    async setType(e) {
        let type = e.target.value;
        let graph = this.props.graph;

        // Check if tier allows heatmap
        if (type === 'heatmap') {
            const featureAvailable = await checkFeature('HEAT_MAP');
            if (!featureAvailable) {
                this.setState({
                    openSubTierModal: 'HEAT_MAP',
                    tierUpdated: () => {
                        this.setType({target: {value: 'heatmap'}});
                    }
                });
                return;
            }
        }

        if (type === 'historic_bar') {
            graph = 'bar';
            type = 'historic';
        }
        if (type.indexOf('breakdown') !== -1) {
            graph = 'bar';
        }
        if (type === 'historic_line') {

            graph = 'line';
            type = 'historic';
        }
        if (type === 'heatmap' || type === 'hour_of_day' || type === 'day_of_week') {
            graph = 'bar';
        }
        let switchToType;
        if (this.props.dataType.dataTypeSibling && (this.props.dataType.dataType === 'instantaneous' && graph === 'bar') || (this.props.dataType.dataType === 'aggregate' && graph === 'line')) {
            switchToType = this.props.dataType.dataTypeSibling.toLowerCase();

        }
        this.props.onChange({
            graph: graph,
            type: type,
            time: this.props.time,
            average: this.props.average,
            combined: this.props.combined,
            switchToType: switchToType
        });
    }

    setGraphType(e) {
        this.props.onChange({
            graph: e.target.value,
            type: this.props.type,
            time: this.props.time,
            average: this.props.average,
            combined: this.props.combined
        });
    }

    setAverageType(e) {
        this.props.onChange({
            graph: this.props.graph,
            type: this.props.type,
            time: this.props.time,
            average: e.target.value,
            combined: this.props.combined
        });
    }

    render() {
        let avgOptions = [
            {
                value: 'average',
                title: 'Average',
                icon: 'FaSlidersH'
            },
            {
                value: 'max',
                title: 'Maximum',
                icon: 'FaArrowAltCircleUp'
            },
            {
                value: 'min',
                title: 'Minimum',
                icon: 'FaArrowAltCircleDown'
            }
        ];
        if (this.props.isAll) {
            avgOptions = [
                {
                    value: 'average',
                    title: 'Average',
                    icon: 'FaSlidersH'
                }
            ];
        }
        if (this.props.dRString === 'last_15_mins') {
            avgOptions = [
                {
                    value: 'average',
                    title: 'Average',
                    icon: 'FaSlidersH'
                }
            ];
        }
        if (this.props.dataType.dataType === 'categorical') {
            avgOptions = [];
            this.props.dataType.unitDetails.metaData.categories.forEach(function (category) {
                avgOptions.push({
                    value: `count_${category.value}`,
                    title: `${category.label} Count`,
                    icon: 'AiOutlineNumber'
                })
                avgOptions.push({
                    value: `duration_${category.value}`,
                    title: `${category.label} Duration`,
                    icon: 'FaClock'
                })
            })
        }


        let typeOptions = [];
        let hasSiblingTab = (this.props.dataType.dataTypeSibling && this.props.dataTabs.find(t => t.dataType.type === this.props.dataType.dataTypeSibling));
        if (this.props.dataType.dataType === 'instantaneous' || this.props.dataType.dataType === 'categorical' || hasSiblingTab) {
            typeOptions.push({
                value: 'historic_line',
                title: 'Line Graph',
                icon: 'FaChartLine',
                color: 'gd-grey'
            })
        }
        if (this.props.dataType.dataType === 'categorical') {
            typeOptions.push({
                value: 'historic_bar',
                title: 'Bar Graph',
                icon: 'FaChartBar',
                color: 'gd-grey'
            })
        }
        if (this.props.dataType.dataType === 'aggregate' || hasSiblingTab) {
            typeOptions.push({
                value: 'historic_bar',
                title: 'Bar Graph',
                icon: 'FaChartBar',
                color: 'gd-grey'
            })
            if ((this.props.filterType === 'site_id' || this.props.filterType === 'site_group_id' || this.props.filterType === 'group_id' || this.props.filterType === 'org_partner_id') && !this.props.isAll) {
                typeOptions.push(
                    {
                        value: 'breakdown',
                        title: 'Device Breakdown',
                        icon: 'FaPlug',
                        color: 'gd-grey'
                    }
                );
                typeOptions.push(
                    {
                        value: 'category_breakdown',
                        title: 'Category Breakdown',
                        icon: 'AiOutlineAppstoreAdd',
                        color: 'gd-grey'
                    }
                );
            }
            if ((this.props.filterType === 'site_group_id' || this.props.filterType === 'org_partner_id') && !this.props.isAll) {
                typeOptions.push(
                    {
                        value: 'site_breakdown',
                        title: 'Site Breakdown',
                        icon: 'FaBuilding',
                        color: 'gd-grey'
                    }
                );
            }
            typeOptions.push(
                {
                    value: 'hour_of_day',
                    title: 'Hour of Day Average',
                    icon: 'FaClock',
                    color: 'gd-grey'
                }
            );
            typeOptions.push(
                {
                    value: 'day_of_week',
                    title: 'Day of Week Average',
                    icon: 'FaCalendar',
                    color: 'gd-grey'
                },
            )
            typeOptions.push(
                {
                    value: 'heatmap',
                    title: 'Heatmap',
                    icon: 'FiGrid',
                    color: 'gd-grey'
                },
            )
        }
        let averageDropdown;
        let aggregateDropdown;
        if (((this.props.category === 'Electricity' || this.props.category === 'Gas' || this.props.category === 'Water' || this.props.category === 'Hot Water' || this.props.category === 'Generation') && this.props.type === 'historic' && this.props.graph === 'line') || (this.props.category !== 'Electricity' && this.props.category !== 'Gas' && this.props.category !== 'Water' && this.props.category !== 'Hot Water' && this.props.category !== 'Generation' && (this.props.dataType.dataType === 'categorical' && this.props.graph === 'bar'))) {
            averageDropdown = (
                <Dropdown nolabel='true'
                          key={'av-dd-' + this.props.average}
                          borderless
                          onChange={this.setAverageType}
                          fixeditems={avgOptions}
                          value={this.props.average}/>
            )
            if (this.props.dataType.dataType !== 'categorical' && (this.props.filterType === 'site_id' || this.props.filterType === 'site_group_id' || this.props.filterType === 'group_id' || this.props.filterType === 'org_partner_id')) {
                let aggregateOptions = [
                    {
                        title: 'Total',
                        icon: 'FaCalculator',
                        value: true
                    }

                ];
                if ((this.props.filterType !== 'site_group_id' && this.props.filterType !== 'org_partner_id') || (this.props.filterId && this.props.filterId.substr(0, 3) !== 'all')) {
                    aggregateOptions.push({
                        title: 'By Device',
                        icon: 'FaPlug',
                        value: false
                    });
                }
                aggregateDropdown = (
                    <Dropdown nolabel='true'
                              key={'ag-dd-' + this.props.combined}
                              borderless
                              onChange={this.setCombined}
                              fixeditems={aggregateOptions}
                              value={this.props.combined}/>
                )
            }
        }
        let typeValue = this.props.type;
        if (this.props.type === 'historic') {
            if (this.props.graph === 'line') {

                typeValue = 'historic_line'
            }
            if (this.props.graph === 'bar') {

                typeValue = 'historic_bar'
            }
        }
        if (this.props.dataType === 'instantaneous') {
            if (!this.props.graph || this.props.graph === 'bar') {
                typeValue = 'historic_line'
            }
        } else if (this.props.dataType === 'aggregate') {
            if (!this.props.graph || this.props.graph === 'line') {
                typeValue = 'historic_bar'
            }
        }
        if (!typeOptions.find(t => t.value === typeValue)) {
            this.setType({target: typeOptions[0]})
        }

        return (
            <div className={"graph-type-picker"}>
                {this.state.openSubTierModal ? <SubTierModal open={this.state.openSubTierModal}
                                                             tierUpdated={this.state.tierUpdated}
                                                             onClose={() => this.setState({openSubTierModal: false})}/> : ''}
                <Dropdown nolabel='true' onChange={this.setType}
                          key={'ty-dd'}
                          borderless
                          fixeditems={typeOptions} value={typeValue}/>
                {this.props.type === 'breakdown' ? (
                        <Dropdown nolabel='true'
                                  borderless
                                  key={'hist-dd'}
                                  onChange={(e) => this.props.onChange({
                                      graph: this.props.graph,
                                      type: this.props.type,
                                      time: e.target.value
                                  })}
                                  fixeditems={[
                                      {
                                          value: 'historic',
                                          title: 'Historic',
                                          icon: 'FaHistory'
                                      },
                                      {
                                          value: 'realtime',
                                          title: 'Real-time',
                                          icon: 'FaClock'
                                      }
                                  ]}
                                  value={this.props.time}/>)
                    : ''}

                {/*{(this.props.category === 'Electricity' || this.props.category === 'Gas' || this.props.category === 'Water' || this.props.category === 'Hot Water' || this.props.category === 'Generation') && this.props.type === 'historic' ? (*/}
                {/*    <Dropdown className={"graph-type"} nolabel='true' onChange={this.setGraphType}*/}
                {/*              key={'lg-dd'}*/}
                {/*              fixeditems={[*/}
                {/*                  {*/}
                {/*                      value: 'line',*/}
                {/*                      title: 'Line Graph'*/}
                {/*                  },*/}
                {/*                  {*/}
                {/*                      value: 'bar',*/}
                {/*                      title: 'Bar Graph'*/}
                {/*                  },*/}
                {/*              ]} value={this.props.graph}/>) : ''}*/}
                {aggregateDropdown}
                {averageDropdown}
            </div>
        )
    }

}

export default GraphTypePicker;
